import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'cosmos-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SubHeaderComponent {
  @Input() title: string;
}
